import { render } from "./DataHeader.vue?vue&type=template&id=28d54e54&scoped=true"
import script from "./DataHeader.vue?vue&type=script&lang=js"
export * from "./DataHeader.vue?vue&type=script&lang=js"

import "./DataHeader.vue?vue&type=style&index=0&id=28d54e54&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dendro-plots/dendro-plots/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d54e54"]])

export default __exports__